import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Table,
  Form,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import { Link, Redirect } from "react-router-dom";
// react plugin used to create charts
import { Line } from "react-chartjs-2";
// react plugin for creating vector maps
import { VectorMap } from "react-jvectormap";
import TagsInput from "react-tagsinput";
// react plugin used to create DropdownMenu for selecting items
import Select from "react-select";
// react plugin used to create switch buttons
// import Switch from "react-bootstrap-switch";

import {
  PanelHeader,
  Stats,
  Statistics,
  CardCategory,
  Progress,
  CardStats,
  Button
} from "components";

import Slider from "nouislider";
import wNumb from "wnumb";
import moment from "moment";

import { Switch, Button as AntButton, Space } from 'antd';
import { accessloghead as thead, accesslogbody as tbody } from "variables/general";
import { DeleteOutlined, PlusOutlined  } from '@ant-design/icons';

moment.locale("es");
var sliders = [];
var initialized_sliders = [];

class Configuration extends React.Component {
  constructor(props) {
    super(props);
    /* ////console.log("########## PROPS ###########");
    ////console.log(props); */
    this.state = {
      isCheckingFaceExists: true,
      faceExists: false,
      password: [],
      channels: [
        {
          label: "Móvil",
          value: 1
        },
        {
          label: "Facturación",
          value: 2
        }
      ]
    };

    sliders = [];
    initialized_sliders = [];

    // this.createMobileCards = this.createMobileCards.bind(this);
    this.createConfigurationForm = this.createConfigurationForm.bind(this);
    this.isPasswordReady = this.isPasswordReady.bind(this);
    this.setPassword = this.setPassword.bind(this);
    this.faceExists = this.faceExists.bind(this);
  }
  componentDidMount() {
    // var sliders = [];
    // var slider1 = this.refs.slider1;
    // Slider.create(slider1, {
    //   start: [5],
    //   connect: [true, false],
    //   step: 1,
    //   range: { min: 2, max: 10 },
    //   behaviour: 'tap-drag',
    //   tooltips: true,
    //   format: wNumb({
    //       decimals: 0
    //   }),
    //   animate: true
    // });
    this.props.get_configuration();
    this.faceExists();
  }

  async faceExists() {
    this.props.userData.faceExists().then(result => {
      this.setState({
        isCheckingFaceExists: false
      });
      // console.log("Result addFace", result);
      if (result.ok) {
        this.setState({
          faceExists: result.exists
        });
      } else {
        console.log("Something went wrong: " + result.error);
      }
    })
    .catch((error) => {
      this.setState({
        isCheckingFaceExists: false
      });
      // Error 😨
      console.log("Error al comprobar la existencia de la cara: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  
  componentDidUpdate(prevProps, prevState) {
    Object.keys(sliders).map(tweak => {
      let tweak_id = tweak;
      tweak = sliders[tweak];
      if (tweak.ref && !initialized_sliders[tweak_id]) {
        var current_slider = tweak.ref;
        tweak = tweak.tweak;
        Slider.create(current_slider, {
          start: [tweak.value],
          connect: [true, false],
          step: tweak.step,
          range: { min: tweak['min-value'], max: tweak['max-value'] },
          behaviour: 'tap-drag',
          tooltips: true,
          format: wNumb({
            decimals: 0
          }),
          animate: true
        }).on('change', function (e) {
          let change = {
            value: parseInt(e[0]),
            id: tweak.id
          };
          prevProps.set_configuration([change]);
        });
        initialized_sliders[tweak_id] = true;
      }
    });
    if (
      !this.props.state.isChangingOwnPass &&
      prevProps.state.isChangingOwnPass &&
      this.props.state.changingOwnPassSuccess
    ) {
      let auxPass = this.state.password;
      auxPass['password'] = {
        pass1: "",
        pass2: "",
        old: ""
      };
      this.setState({ password: auxPass });
    }
  }
  isPasswordReady(id) {
    if (!(id in this.state.password)) return false;
    let result = false;
    let auxPassword = this.state.password;
    let currentPassword = auxPassword[id];
    if (currentPassword.pass1 && currentPassword.pass1.length > 7) {
      if (
        currentPassword.pass2 &&
        currentPassword.pass1 === currentPassword.pass2 &&
        currentPassword.old &&
        currentPassword.old.length > 0
      )
        result = true;
    }

    return result;
  }
  setPassword(id) {
    console.log("setPassword (id): ", id);
    console.log("setPassword (this.state.password): ", this.state.password);
    if (!(id in this.state.password)) return;
    let password = this.state.password[id];
    switch (id) {
      case "password":
        this.props.setPassword({
          password: password.pass1,
          old: password.old
        });
        break;
      default:
        break;
    }
  }
  createConfigurationForm(configuration) {
    let result = null;
    let channelsTest = [
      {
        label: "Móvil",
        value: 84
      },
      {
        label: "Facturación",
        value: 282
      },
      {
        label: "Admin",
        value: 75
      },
      {
        label: "Portabilidad",
        value: 170
      }
    ];

    if (configuration && Object.keys(configuration).length > 0) {
      Object.keys(configuration).map(category_key => {
        let category = configuration[category_key];
        if (result === null) result = [];
        let tweaks = category.tweaks;
        tweaks = Object.keys(tweaks).map(tweak_key => {
          let tweak = tweaks[tweak_key];
          let currentTweak = null;
          switch (tweak.input) {
            case "slider":
              sliders[tweak.id] = {
                tweak: tweak,
                ref: React.createRef()
              };
              currentTweak = (
                <div
                  className="slider"
                  style={{ marginTop: "40px" }}
                  ref={el => (sliders[tweak.id].ref = el)}
                />
              );
              break;
            case "tags":
              currentTweak = (
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  isMulti
                  isDisabled={!tweak.editable}
                  closeMenuOnSelect={false}
                  placeholder="Seleccionar canales"
                  name="channels"
                  value={tweak.value.map(tag => {return {label: tag.name, value: tag.id};})}
                  options={channelsTest}
                  noOptionsMessage={() => "Cargando canales"}
                  // onChange={value =>
                  //   this.setState({ channels: value })
                  // }
                />
              );
              break;
            case "password":
              currentTweak = (
                <Row>
                  <Col xs={12} md={3}>
                    <Label>Nueva contraseña</Label>
                    <FormGroup>
                      <Input
                        // disabled={!isAdmin}
                        type="password"
                        // placeholder="12345789"
                        value={
                          tweak.id in this.state.password ? 
                          this.state.password[tweak.id].pass1 : ""}
                        onChange={event => {
                          let newValue = event.target.value;
                          let auxPassword = this.state.password;
                          let auxPasswordLocal = {};
                          if (tweak.id in auxPassword)
                            auxPasswordLocal = auxPassword[tweak.id];
                          auxPasswordLocal.pass1 = newValue;
                          auxPassword[tweak.id] = auxPasswordLocal;
                          this.setState({ password: auxPassword });
                        }}
                      />
                    </FormGroup>
                  </Col>
                  <Col xs={12} md={3}>
                    <Label>Repetir contraseña</Label>
                    <FormGroup>
                      <Input
                        // disabled={!isAdmin}
                        type="password"
                        // placeholder="12345789"
                        value={
                          tweak.id in this.state.password ? 
                          this.state.password[tweak.id].pass2 : ""}
                        onChange={event => {
                          let newValue = event.target.value;
                          let auxPassword = this.state.password;
                          let auxPasswordLocal = {};
                          if (tweak.id in auxPassword)
                            auxPasswordLocal = auxPassword[tweak.id];
                          auxPasswordLocal.pass2 = newValue;
                          auxPassword[tweak.id] = auxPasswordLocal;
                          this.setState({ password: auxPassword });
                        }}
                      />
                    </FormGroup>
                  </Col>
                  <Col xs={12} md={3}>
                    <Label>Contraseña actual</Label>
                    <FormGroup>
                      <Input
                        // disabled={!isAdmin}
                        type="password"
                        // placeholder="12345789"
                        value={
                          tweak.id in this.state.password ? 
                          this.state.password[tweak.id].old : ""}
                        onChange={event => {
                          let newValue = event.target.value;
                          let auxPassword = this.state.password;
                          let auxPasswordLocal = {};
                          if (tweak.id in auxPassword)
                            auxPasswordLocal = auxPassword[tweak.id];
                          auxPasswordLocal.old = newValue;
                          auxPassword[tweak.id] = auxPasswordLocal;
                          this.setState({ password: auxPassword });
                        }}
                      />
                    </FormGroup>
                  </Col>
                  <Col xs={12} md={3}>
                    <Button
                      disabled={!this.isPasswordReady(tweak.id) || this.props.state.isChangingOwnPass}
                      onClick={() => {
                        if (!this.isPasswordReady(tweak.id)) {
                          let options = {
                            place: "tr",
                            message: "¡Vicente, deja de tocar!",
                            type: "error",
                            icon: "now-ui-icons ui-1_check",
                            autoDismiss: 3
                          };
                          if (this.state.debug) this.showNotification(options);
                        } else {
                          this.setPassword(tweak.id);
                        }
                        // console.log("cambiar pulsado", this.props);
                      }}
                      color={
                        this.isPasswordReady(tweak.id) ? "primary" : "default"
                      }
                      style={{ marginTop: "25px" }}
                      leftLabel={"now-ui-icons " + (this.props.state.isChangingOwnPass? "arrows-1_refresh-69 spin" : "objects_key-25")}
                    >
                      {this.props.state.isChangingOwnPass ? "Cambiando" : "Cambiar"}
                    </Button>
                  </Col>
                </Row>
              );
              break;
            case "switch":
              currentTweak = (
                <CardStats className="justify-content-center">
                  <Switch
                    onText="On"
                    offText="Off"
                    defaultValue={tweak.value}
                    value={tweak.id === "face-recognition" ? (tweak.value && this.state.faceExists) : tweak.value}
                    disabled={tweak.id === "face-recognition" && (this.state.isCheckingFaceExists || !this.state.faceExists)}
                    onChange={(elm, state) => {
                      console.log("onChange switch (elm)", elm);
                      console.log("onChange switch (state)", state);
                      let change = {
                        value: state,
                        id: tweak.id
                      };
                      // tweak.value = state;
                      // tweaks[tweak_key] = tweak;
                      // category.tweaks = tweaks;
                      let _configuration = configuration;
                      _configuration[category_key].tweaks[tweak_key].value = state;
                      this.props.userData.changeConfiguration(_configuration);
                      this.props.set_configuration([change]);
                    }}
                  />
                  {tweak.id !== "face-recognition" && (
                    <span id="switch-label" className={tweak.value ? "on" : "off"}>
                      Estado{" "}
                      <span className="switch-status">
                        {tweak.value ? "activado" : "desactivado"}
                      </span>
                    </span>
                  )}
                  {tweak.id === "face-recognition" && (
                    <span>
                      <span
                        id="switch-label"
                        className={
                          tweak.value && this.state.faceExists ? "on" : "off"
                        }
                      >
                        Reconocimiento facial {" "}
                        <span className="switch-status">
                          {this.state.isCheckingFaceExists ? <span><i className="now-ui-icons arrows-1_refresh-69 spin" /> Comprobando si la cara existe</span> : ((tweak.value && this.state.faceExists) ? "activado" : "desactivado")}
                        </span>
                        {!this.state.isCheckingFaceExists &&
                        !this.state.faceExists ? (
                          <span>
                            . <u>Antes de empezar</u>, es necesario crear una
                            cara: pulsa sobre el botón{" "}
                            <i>
                              <b>Crear cara</b>
                            </i>
                            .
                          </span>
                        ) : null}
                      </span>
                      {!this.state.isCheckingFaceExists && <Button
                        onClick={() => {
                          this.props.history.push("/configuracion/cara");
                        }}
                        color="primary"
                        leftLabel={"now-ui-icons users_circle-08"}
                      >
                        {this.state.faceExists ? "Entrenar reconocimiento" : "Crear cara"}
                      </Button>}
                    </span>
                  )}
                </CardStats>
              );
              break;
            default:
              currentTweak = (
                <div>
                  <span>Controlador no encontrado</span><br />
                  {JSON.stringify(tweak)}
                </div>
              );
              break;
          }
          currentTweak = (
            <Col xs={12} md={(tweak.id === "password" || tweak.id === "face-recognition") ? 12 : 6} key={tweak.id}>
              <CardTitle className="h-nomargin">{tweak.title}</CardTitle>
              <CardCategory className="description">{tweak.description}</CardCategory>
              {currentTweak}
            </Col>
          );
          return currentTweak;
        });
        let iconStyle = {
          marginRight: "10px",
          position: "relative",
          bottom: "-3px"
        };
        let categoryIcon = category.icon ? <i style={iconStyle} className={category.icon} /> : null;
        result.push(
          <Row key={category.id}>
            <Col xs={12}>
              <div className="text-center">
                <CardTitle tag="h4">
                  {categoryIcon}
                  {category.title}
                </CardTitle>
                <CardCategory>{category.description}</CardCategory>
              </div>
            </Col>
            <br />
            {tweaks}
            <br />
          </Row>
        );
      });
    }

    return result;
  }
  render() {
    let channelsTest = [
      {
        label: "Móvil",
        value: 1
      },
      {
        label: "Facturación",
        value: 2
      },
      {
        label: "Admin",
        value: 3
      },
      {
        label: "Portabilidad",
        value: 4
      }
    ];
    return (
      <div id="configuration-page">
        <PanelHeader
          content={
            <div className="header text-center">
              <h2 className="title">Configuración</h2>
              {/* <p className="category">
                El ojo que todo lo ve
              </p> */}
            </div>
          }
        />
        <div className="content">
          <Row>
            <Col xs={12} md={6}>
              <Card>
                <CardBody>
                  <CardTitle>Seguridad</CardTitle>
                  <CardTitle>Protocolos permitidos de conexión</CardTitle>
                  <Switch checked={false} /> PPTP<br />
                  <Switch checked={true} /> SSL/TLS<br />
                  <Switch checked={true} /> IPsec IKEv2<br />
                  <Switch checked={false} /> L2TP<br />
                  <CardTitle>Protección de la conexión</CardTitle>
                  <Switch checked={true} /> Detección y prevención de intrusiones<br />
                  <Switch checked={true} /> Análisis avanzado antimalware<br />
                  <Switch checked={true} /> Filtrado de conexiones por IP<br />
                  <CardTitle>Lista de IPs permitidas</CardTitle>
                  <Table responsive striped bordered hover>
                    <thead className="text-primary">
                      <tr>
                        <th className="text-left">
                          IP/Rango {" "}
                          <AntButton
                            type="primary"
                            icon={<PlusOutlined  />}
                          />
                        </th>
                        <th className="text-left">Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr><td className="text-left">217.160.0.0/24</td>
                        <td className="text-left">
                          <AntButton
                            type="primary"
                            icon={<DeleteOutlined />}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
            <Col xs={12} md={6}>
              <Card>
                <CardBody>
                  <CardTitle>Logs</CardTitle>
                  <CardTitle>Información de las conexiones</CardTitle>
                  <Switch checked={true} /> Conexión y desconexión de la VPN<br />
                  <Switch checked={true} /> Protocolo VPN utilizado<br />
                  <Switch checked={false} /> Tráfico total por conexión<br />
                  <Switch checked={true} /> IP origen<br />
                </CardBody>
              </Card>
            </Col>
            <Col xs={12}>
              <Card className="lista-vpn">
                <CardHeader>
                  <CardTitle tag="h4">Log de acceso administración</CardTitle>
                </CardHeader>
                <CardBody className="table-full-width">
                  <Table responsive striped bordered hover>
                    <thead className="text-primary">
                      <tr>
                        {thead.map((prop, key) => {
                          if (key === thead.length - 1)
                            return (
                              <th key={key} className="text-left">
                                {prop}
                              </th>
                            );
                          return <th key={key}>{prop}</th>;
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {tbody.map((prop, key) => {
                        return (
                          <tr key={key} className={prop.className}>
                            {prop.data.map((prop, key) => {
                              if (key === thead.length - 1)
                                return (
                                  <td key={key} className="text-left">
                                    {prop}
                                  </td>
                                );
                              return <td key={key}>{prop}</td>;
                            })}
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </CardBody>
                <Col className="text-center">
                  <Button>Mostrar más registros</Button>
                </Col>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default Configuration;



// WEBPACK FOOTER //
// ./src/views/Configuration/Configuration.jsx